import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import TextInput from '../TextInput'
import Button from '../Button'
import { Container } from './styles'

const CustomButton = styled(Button)`
  margin-left: 15px;
  @media (max-width: 1000px) {
    display: none;
  }
`

export default class SearchPanel extends PureComponent {
  text = ''

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    buttonText: PropTypes.string,
    hideButton: PropTypes.bool
  }

  static defaultProps = {
    onChange: () => {},
    value: '',
    placeholder: '',
    buttonText: '',
    hideButton: false
  }

  handleTextChange = (text) => {
    this.text = text
  }

  onPress = () => {
    this.props.onChange(this.text)
  }

  render() {
    const {
      placeholder, buttonText, hideButton, value
    } = this.props
    return (
      <Container>
        <TextInput
          value={value}
          onEnterPress={this.onPress}
          icon="search"
          onChange={this.handleTextChange}
          placeholder={placeholder}
          search
        />
        {!hideButton && <CustomButton onPress={this.onPress}>{buttonText}</CustomButton>}
      </Container>
    )
  }
}
